import CityPageTemplate from "../city-template/CityPageTemplate";
import { waldorfConfig } from "./data";

export default function WaldorfPage() {
  return <CityPageTemplate config={waldorfConfig} />;
}